export default __webpack_public_path__ + "static/media/seguranca.36e03a65.svg";